// src/components/Tickets/TicketsPage.jsx
import React, { useMemo, useContext, useState } from 'react'
import { useParams } from 'react-router-dom'
import TicketList from './TicketList'
import TicketCreate from './TicketCreate'
import TicketCategories from './TicketCategories'
import { AuthContext } from '../../contexts/AuthContext'

export default function TicketsPage() {
  const { ticketId } = useParams()
  const { user, hasPermission } = useContext(AuthContext)
  const [tab, setTab] = useState('list')
  const [refresh, setRefresh] = useState(0)

  const isSupport = useMemo(() => {
    if (!user) return false
    const roles = user.roles || []
    if (roles.some(r => r.name === 'admin' || r.name === 'ticket_support')) return true
    return hasPermission('tickets_categories_manage')
  }, [user, hasPermission])

  const tabs = useMemo(() => {
    const base = [
      { key: 'list',   label: 'I miei ticket' },
      { key: 'create', label: 'Crea ticket'   },
    ]
    if (isSupport) base.push({ key: 'cats', label: 'Categorie' })
    return base
  }, [isSupport])

  return (
    <div className="tickets-wrap">
      {/* NAV TABS — riuso rr-tabs con padding mobile */}
      <nav className="tickets-tabs" aria-label="Ticket tabs">
        <div className="tickets-tabs__scroller">
          {tabs.map(t => (
            <button
              key={t.key}
              type="button"
              className={`tickets-tabs__btn ${tab === t.key ? 'is-active' : ''}`}
              onClick={() => setTab(t.key)}
            >
              {t.label}
            </button>
          ))}
        </div>
      </nav>



      {tab === 'list'   && (
        <TicketList
          refreshKey={refresh}
          onChanged={() => setRefresh(k => k + 1)}
          initialTicketId={ticketId ? Number(ticketId) : null}
        />
      )}
      {tab === 'create' && (
        <TicketCreate
          onCreated={() => { setTab('list'); setRefresh(k => k + 1) }}
        />
      )}
      {tab === 'cats' && isSupport && <TicketCategories />}
    </div>
  )
}
